import { FormValues } from "@/types/loan";
import { supabase } from "@/integrations/supabase/client";
import { 
  sanitizeString,
  sanitizeEmail,
  sanitizePhoneNumber
} from "@/utils/security";

export const saveLoanLead = async (data: FormValues): Promise<void> => {
  try {
    const sanitizedData = {
      firstName: sanitizeString(data.firstName),
      lastName: sanitizeString(data.lastName),
      email: sanitizeEmail(data.email),
      phoneNumber: sanitizePhoneNumber(data.phoneNumber)
    };

    console.log("Saving loan lead to database:", {
      firstName: sanitizedData.firstName,
      lastName: sanitizedData.lastName,
      email: sanitizedData.email,
      phone: sanitizedData.phoneNumber,
      loanType: data.loanType || 'kulutusluotto',
      loanAmount: data.loanAmount,
      loanPurpose: data.loanPurpose
    });

    const { error: loanLeadError } = await supabase.rpc('insert_loan_lead', {
      p_first_name: sanitizedData.firstName,
      p_last_name: sanitizedData.lastName,
      p_email: sanitizedData.email,
      p_phone: sanitizedData.phoneNumber,
      p_loan_type: data.loanType || 'kulutusluotto',
      p_loan_amount: data.loanAmount,
      p_loan_purpose: data.loanPurpose || 'Muu',
      p_marketing_consent: data.marketingConsent || false
    });

    if (loanLeadError) {
      console.error("Error saving loan lead:", loanLeadError);
      throw loanLeadError;
    } else {
      console.log("Loan lead saved successfully to database");
    }
  } catch (error) {
    console.error("Error saving loan lead:", error);
    throw error;
  }
};

export const saveMarketingContact = async (data: FormValues): Promise<void> => {
  if (!data.marketingConsent) {
    console.log("Marketing consent not given, skipping marketing contact save");
    return;
  }

  try {
    const sanitizedData = {
      firstName: sanitizeString(data.firstName),
      lastName: sanitizeString(data.lastName),
      email: sanitizeEmail(data.email)
    };

    console.log("Saving marketing contact to database:", {
      email: sanitizedData.email,
      name: `${sanitizedData.firstName} ${sanitizedData.lastName}`,
      marketingConsent: data.marketingConsent,
      source: 'loan_application'
    });

    const { error: marketingError } = await supabase.rpc('insert_marketing_contact', {
      p_email: sanitizedData.email,
      p_name: `${sanitizedData.firstName} ${sanitizedData.lastName}`,
      p_marketing_consent: data.marketingConsent,
      p_source: 'loan_application'
    });

    if (marketingError) {
      console.error("Error saving marketing contact:", marketingError);
      console.error("Marketing contact error details:", marketingError);
      throw marketingError;
    } else {
      console.log("Marketing contact saved successfully to database");
    }
  } catch (error) {
    console.error("Error saving marketing contact:", error);
    throw error;
  }
};